import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {Dialog, DialogTitle, DialogContent} from "@mui/material";

import Form from "views/genders/components/form";

import {reset} from "actions/gender/create";

import getTranslationInitialValues from "utils/getTranslationInitialValues";

CreateGenderDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    initialName: PropTypes.string,
    onCreated: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

/**
 * Standalone wrapper around the gender creation form of the genders page for
 * the quick-create flow. The created gender is read from the redux state the
 * form dispatches to; the state is reset on open so a leftover from the
 * genders page cannot be mistaken for our creation.
 */
function CreateGenderDialog({isOpen, initialName, onCreated, onClose, created, reset}) {
    useEffect(() => {
        if (isOpen) {
            reset();
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen && created) {
            onCreated(created);
        }
    }, [created]);

    if (!isOpen) {
        return null;
    }

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth={'sm'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage id={'gender.form.create.title'} />
            </DialogTitle>
            <DialogContent>
                <Form
                    closeDialog={onClose}
                    initialValues={{translations: getTranslationInitialValues(initialName ?? '', 'value')}}
                />
            </DialogContent>
        </Dialog>
    );
}

const mapStateToProps = state => {
    return {
        created: state.gender.create.created,
    }
};

const mapDispatchToProps = dispatch => ({
    reset: () => dispatch(reset()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateGenderDialog);
